import { render, staticRenderFns } from "./IdCard.vue?vue&type=template&id=40b2bdbc"
import script from "./IdCard.vue?vue&type=script&lang=js"
export * from "./IdCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports